import React, { Component } from 'react'
import { Row, Col, Card, Table, Input, Typography, Space, Popover, Button, Checkbox } from 'antd'
import './index.css'
import { Http } from '../../utils'
import { COOKIE, getCookie } from '../../utils/cookie'
import { timezone } from '../../constants/constants'
import moment from 'moment'
// import { SearchOutlined } from '@ant-design/icons'
import planeDarkIcon from '../../assets/images/plane-icon-dark.svg'
import LocIcon from '../../assets/images/loc.png'
import ManifestIcon from '../../assets/images/manifest.png'
import GoodsOnHandIcon from '../../assets/images/goods-on-hand.png'
import ShipmentAcceptedIcon from '../../assets/images/shipment-accepted.png'
import BookingReceivedIcon from '../../assets/images/booking-received.png'
import FlightAssignedIcon from '../../assets/images/flt-assigned.png'
import { CaretDownOutlined } from '@ant-design/icons'

let format = 'DDMMMYY HH:mm:ss'
const { Search } = Input

class AwbDetails extends Component {
  constructor() {
    super()
    this.state = {
      search: { number: '', },
      notFound: false,
      subscribe: false,
      data: [],
      awbData: {},
      flightData: {},
      uldData: {},
      subscribedUsers: [],
      timezone: getCookie(COOKIE.TIMEZONE),
      station: getCookie(COOKIE.STATION),
      ext: timezone.find((item) => item.value === getCookie(COOKIE.STATION))?.ext || 'EST',
      checkedList: [],
      plainOptions: ['Breakdown', 'Buildup', 'Haulout'],
    }
  }

  search = async () => {
    if (!this.state.search.number) {
      return
    }
    let url = `gatekeeper/search?search=${this.state.search.number}`
    await Http.get(url).then(resp => {
      this.setState({
        notFound: false,
        subscribe: false
      })
      if (resp?.data?.data?.length > 0) {
        this.auditAwb()
        this.checkSubscribe()
        this.setState({ data: resp.data.data }, () => {
          this.getAwbData()
        })
      } else {
        this.setState({ data: [] })
        this.searchOld()
      }
    })

  }

  checkSubscribe = async () => {
    this.setState({ subscribedUsers: [] })
    let url = `/gatekeeper/subscribe?awb_no=${this.state.search.number}&user=${getCookie(COOKIE.ID)}&station=${this.state.station}`
    await Http.get(url).then(resp => {
      if (resp?.data?.data) {
        const index = resp?.data?.data.findIndex(item => item.user_id == getCookie(COOKIE.ID))
        this.setState({ subscribedUsers: resp?.data?.data })
        if (index > -1) {
          this.setState({ subscribe: true })
        } else {
          this.setState({ subscribe: false })
        }
      } else {
        this.setState({ subscribe: false })
      }
    })
  }

  onSubscibe = async () => {
    let url = '/gatekeeper/subscribe'
    let data = {
      awb_no: this.state.search.number,
      user: getCookie(COOKIE.ID),
      station: this.state.station,
      area: this.state.checkedList
    }
    await Http.post(url, data).then(() => {
      this.checkSubscribe()
    })
  }

  getAwbData = async () => {
    if (this.state.data && this.state.data.length > 0) {
      let awb = this.state.data.find(msg => msg.type === 'ECIBOOK')?.msg
      let data = [...this.state.data]
      if (awb) {
        if (awb?.bookingPublishEvent) {
          this.setState({
            data: data.reverse(),
            awbData: {
              awb_number: awb?.bookingPublishEvent?.bookingDetails?.awb,
              org: awb?.bookingPublishEvent?.bookingDetails?.origin,
              dest: awb?.bookingPublishEvent?.bookingDetails?.destination,
              prod_code: awb?.bookingPublishEvent?.bookingDetails?.product,
              status: awb?.bookingPublishEvent?.bookingDetails?.bookingStatus,
              date: awb?.bookingPublishEvent?.bookingDetails?.shippingDate,
              pay: awb?.bookingPublishEvent?.bookingDetails?.paymentType,
              wgt: awb.bookingPublishEvent?.bookingDetails?.shipmentDetails.reduce((a, b) => +a + +b?.pieces, 0),
              unit: awb.bookingPublishEvent?.bookingDetails?.unitOfMeasure?.weight,
              pcs: awb.bookingPublishEvent?.bookingDetails?.shipmentDetails.reduce((a, b) => +a + +b?.pieces, 0),
            }
          })
        } else {
          this.setState({
            data: data.reverse(),
            awbData: {
              awb_number: this.state.search.number,
              org: awb?.awbinfo?.routing?.origin?.station,
              dest: awb?.awbinfo?.routing?.dest?.station,
              prod_code: awb?.awbinfo?.prod,
              status: '',
              date: awb?.awbinfo?.datetime?.creation?.date?.content ? moment(awb?.awbinfo?.datetime?.creation?.date?.content + ' ' + (awb?.awbinfo?.datetime?.creation?.time || '0000'), 'DDMMMYY HHmm').format('YYYY-MM-DD HH:mm') : null,
              pay: '',
              wgt: awb?.bkginfo?.suggested?.wgt,
              unit: awb?.awbinfo?.wuni,
              pcs: awb?.bkginfo?.suggested?.pcs,
            }
          })
        }
      } else {
        this.setState({
          data: data.reverse(),
          awbData: {
            awb_number: this.state.search.number,
            org: '',
            dest: '',
            prod_code: '',
            status: '',
            date: '',
            pay: '',
            wgt: 0,
            unit: '',
            pcs: 0,
          }
        })
      }
    }
  }

  searchOld = async () => {
    let url = `/gatekeeper?search=${this.state.search.number}`
    await Http.get(url).then(resp => {
      if (resp?.data?.data?.length > 0) {
        this.auditAwb()
        this.setState({ data: resp?.data?.data }, () => {
          this.getAwbData()
        })
      } else {
        this.setState({
          data: [],
          notFound: true
        })
      }
    })
  }

  auditAwb = async () => {
    let url = `/audit_awb?awb_no=${this.state.search.number}`
    let data = []
    await Http.get(url).then(resp => {
      if (resp?.data?.data?.length > 0) {
        resp?.data?.data.map((item) => {
          // if (item?.locations?.length > 0) {
          //   item.locations.map((loc) => {
          //     loc.type = 'LOCATION CHANGE'
          //     loc.message = `Moved from ${loc?.fromLocation} to ${loc?.toLocation}.`
          //     loc.trigger = 'System Triggered'
          //     loc.createdAt = loc?.date
          //     data.push(loc)
          //   })
          // }
          if (item?.goods_infos_histories?.length > 0) {
            item.goods_infos_histories.map((info) => {
              if (info?.event_type?.toUpperCase() === 'AWB UPDATED') {
                info.type = info?.event_type?.toUpperCase()
                info.message = info?.status?.msg ? info?.status?.msg : info?.event_name
                info.trigger = 'System Triggered'
                info.station = item?.station
                data.push(info)
              }
            })
          }
        })
        data = data.sort((a, b) => {
          return new Date(b.createdAt) - new Date(a.createdAt)
        })
        this.setState({ audit: data })
      } else {
        this.setState({ audit: [] })
      }
    })
  }

  getFlightData = async (flight) => {
    this.setState({ flightData: {} })
    let flight_no = flight.split('/')[0]
    let flight_date = flight.split('/')[1].split(' ')[0]
    let flight_org = flight.split('/')[1].split(' ')[1].split('-')[0]
    let flight_dest = flight.split('/')[1].split(' ')[1].split('-')[1]
    if (!flight_no || !flight_date) {
      return
    }
    let url = `/audit/flight?flight_no=${flight_no}&flight_date=${flight_date}&origin=${flight_org}&destination=${flight_dest}`
    await Http.get(url).then(resp => {
      if (resp?.data?.data) {
        this.setState({ flightData: resp.data.data })
      }
    })
  }

  getUldData = async (uld, stn) => {
    this.setState({ uldData: {} })
    await Http.get(`/gatekeeper/uld?uld_no=${uld}&station=${stn}`).then(resp => {
      if (resp?.data?.data) {
        this.setState({ uldData: resp.data.data })
      }
    })
  }


  onChange = (e) => {
    const { name, value } = e.target
    this.setState({
      search: {
        ...this.state.search,
        [name]: value
      }
    })
  }

  onSearch = () => {
    // e.preventDefault()
    this.search()
  }

  parseMsg = (m) => {
    if (m.bookingPublishEvent) {
      let flight = m.bookingPublishEvent?.bookingDetails?.flights?.map(f => f.flightCarrier + f.flightNumber + '/' + moment(f.departureDate).format('DDMMMYY') + ' ' + f.departureAirport + '-' + f.arrivalAirport + ' ' + f.bookingStatus).join(',')
      return {
        fromLocation: '',
        toLocation: '',
        wgt: m.bookingPublishEvent?.bookingDetails?.shipmentDetails.reduce((a, b) => +a + +b?.pieces, 0),
        unit: m.bookingPublishEvent?.bookingDetails?.unitOfMeasure?.weight,
        pcs: m.bookingPublishEvent?.bookingDetails?.shipmentDetails.reduce((a, b) => +a + +b?.pieces, 0),
        flight: flight,
      }
    }
    if (m?.awbinfo) {
      let flight = m?.bkginfo?.segs?.seg?.map((f) => f?.fltinfo?.flight + '/' + moment(f?.fltinfo?.date).format('DDMMMYY') + ' ' + f?.origin?.station + '-' + f?.dest?.station).join(',')
      return {
        fromLocation: '',
        toLocation: '',
        wgt: parseFloat(m?.bkginfo?.suggested?.wgt || 0),
        unit: m.awbinfo?.wuni,
        pcs: m.bkginfo?.suggested?.pcs,
        flight: flight,
      }
    }
    if (m.messageHeaderDocument && m.messageHeaderDocument?.name?.value === 'Transport Loading Report') {
      let flight = m.businessHeaderDocument?.id?.value?.slice(0, -11) + '/' + moment(m.businessHeaderDocument?.id?.value?.slice(-11, -3)).format('DDMMMYY') + ' ' + m.logisticsTransportMovement?.departureEvent?.occurrenceDepartureLocation?.id?.value + '-' + m?.arrivalEvent?.[0]?.occurrenceArrivalLocation?.id?.value
      let awbs = []
      let ulds = []
      m.arrivalEvent?.[0]?.associatedTransportCargo?.forEach((uld) => {
        if (uld?.includedMasterConsignment) {
          uld?.includedMasterConsignment?.forEach((awb) => {
            if (awb?.transportContractDocument?.id?.value === this.state.search.number) {
              awbs.push(awb)
              ulds.push(uld)
            }
          })
        }
      })
      return {
        fromLocation: '',
        toLocation: '',
        wgt: awbs?.reduce((a, b) => a + +b?.grossWeightMeasure?.value, 0),
        unit: awbs[0]?.grossWeightMeasure?.unitCode,
        pcs: awbs?.reduce((a, b) => a + +b?.totalPieceQuantity?.value, 0),
        ulds: ulds,
        flight: flight,
        org: m.logisticsTransportMovement?.departureEvent?.occurrenceDepartureLocation?.id?.value,
        dest: m?.arrivalEvent?.[0]?.occurrenceArrivalLocation?.id?.value,
      }
    }
    let flight = m.masterConsignment?.reportedStatus[0]?.associatedStatusConsignment[0]?.specifiedLogisticsTransportMovement[0]?.id?.value
    let flightDate = m.masterConsignment?.reportedStatus[0]?.associatedStatusConsignment[0]?.specifiedLogisticsTransportMovement[0]?.departureEvent?.departureOccurrenceDateTime
    let org_dest = m.masterConsignment?.reportedStatus[0]?.associatedStatusConsignment[0]?.specifiedLogisticsTransportMovement[0]?.specifiedLocation?.map(l => l?.id?.value).join('-')
    return {
      fromLocation: m.masterConsignment?.reportedStatus[0]?.associatedStatusConsignment[0]?.handlingInstructions?.fromLocation,
      toLocation: m.masterConsignment?.reportedStatus[0]?.associatedStatusConsignment[0]?.handlingInstructions?.toLocation,
      wgt: m.masterConsignment?.reportedStatus[0]?.associatedStatusConsignment[0]?.grossWeightMeasure?.value,
      unit: m.masterConsignment?.reportedStatus[0]?.associatedStatusConsignment[0]?.grossWeightMeasure?.unitCode,
      pcs: m.masterConsignment?.reportedStatus[0]?.associatedStatusConsignment[0]?.pieceQuantity?.value,
      // msgData.flight ? (msgData.flight + '/' + (msgData.flightDate ? moment(msgData.flightDate).format('DDMMMYY') : '')) : ''
      // uldData?.characteristicCode?.value + uldData?.id?.value + uldData?.operatingParty?.primaryID?.value
      uld: m.masterConsignment?.reportedStatus[0]?.associatedStatusConsignment[0]?.utilizedUnitLoadTransportEquipment?.[0] ? m.masterConsignment?.reportedStatus[0]?.associatedStatusConsignment[0]?.utilizedUnitLoadTransportEquipment[0]?.characteristicCode?.value + m.masterConsignment?.reportedStatus[0]?.associatedStatusConsignment[0]?.utilizedUnitLoadTransportEquipment[0]?.id?.value + m.masterConsignment?.reportedStatus[0]?.associatedStatusConsignment[0]?.utilizedUnitLoadTransportEquipment[0]?.operatingParty?.primaryID?.value : '',
      flight: flight ? flight + '/' + (flightDate ? moment(flightDate).format('DDMMMYY') : '') + ' ' + org_dest : '',
    }
  }

  onChangeCheck = list => {
    this.setState({ checkedList: list })
  }

  onCheckAllChange = e => {
    this.setState({ checkedList: e.target.checked ? this.state.plainOptions : [] })
  }
  
  render() {
    const indeterminate =  this.state.checkedList.length > 0 &&  this.state.checkedList.length < this.state.plainOptions.length
    const checkAll = this.state.plainOptions.length === this.state.checkedList.length
    
    const columns = [
      {
        title: 'Station',
        key: 'station',
        dataIndex: 'station',
        minWidth: 150,
        align: 'center',
        render: (_, row) => {
          if (row?.type === 'MANIFEST') {
            let msgData = this.parseMsg(row.msg)
            return <span>{msgData?.org} - {msgData?.dest}</span>
          }
          return <span>{row?.station}</span>
        }
      },
      {
        title: '',
        key: 'status',
        dataIndex: 'status',
        align: 'center',
        width: 150,
        render: (_, row) => {
          let msgData = this.parseMsg(row.msg)
          if (row?.type === 'ECIBOOK') {
            return <span className='status bkn-rcvd'>
              <img src={BookingReceivedIcon} width='50' height='50' alt='plane' className='table-icons' />
            </span>
          } else if (row?.type?.includes('FSU')) {
            if (row?.type === 'FSU/MAN') {
              return <span className='status flt-status'>
                <img src={ManifestIcon} width='50' height='50' alt='plane' className='table-icons' />
              </span>
            } else if (row?.type === 'FSU/FOH') {
              return <span className='status GDS-status'>
                <img src={GoodsOnHandIcon} width='50' height='50' alt='plane' className='table-icons gds-on-hand' />
              </span>
            } else if (row?.type === 'FSU/RCS') {
              return <span className='status gds-accepted'>
                <img src={ShipmentAcceptedIcon} width='50' height='50' alt='plane' className='table-icons' />
              </span>
            } else if (row?.type === 'FSU/NFD' || row?.type === 'FSU/DLV') {
              return <span className='status gds-delivered'>
                <img src={ShipmentAcceptedIcon} width='50' height='50' alt='plane' className='table-icons' />
              </span>
            } else if (row?.type === 'FSU/RCF') {
              return <span className='status gds-received'>
                <img src={ShipmentAcceptedIcon} width='50' height='50' alt='plane' className='table-icons' />
              </span>
            } else if (row?.type === 'FSU/PRE') {
              return <span className='status flt-pre'>
                <img src={FlightAssignedIcon} width='50' height='50' alt='plane' className='table-icons' />
              </span>
            } else if (row?.type === 'FSU/DIS') {
              return <span className='status gds-rmv'>
                <img src={FlightAssignedIcon} width='50' height='50' alt='plane' className='table-icons' />
              </span>
            } else if (row?.type === 'FSU/FPS') {
              return <span className='status loc-change'>
                <img src={LocIcon} width='50' height='50' alt='plane' className='table-icons' />
              </span>
            }
            return <span>{row.type} | {msgData.fromLocation || '-'} TO {msgData.toLocation || '-'}</span>
          } else {
            return <span>{row.type}</span>
          }
        }
      },
      {
        title: 'Status',
        key: 'status',
        dataIndex: 'status',
        width: 300,
        render: (_, row) => {
          let msgData = this.parseMsg(row.msg)
          if (row?.type === 'ECIBOOK') {
            return <span>BOOKING RCVD</span>
          } else if (row?.type?.includes('FSU')) {
            if (row?.type === 'FSU/MAN') {
              return <span>FLT ASG</span>
            } else if (row?.type === 'FSU/FOH') {
              return <span>GDS ON HAND</span>
            } else if (row?.type === 'FSU/RCS') {
              return <span>GDS ACCEPTED</span>
            } else if (row?.type === 'FSU/NFD' || row?.type === 'FSU/DLV') {
              return <span>GDS DELIVERED</span>
            } else if (row?.type === 'FSU/RCF') {
              return <span>GDS RECEIVED</span>
            } else if (row?.type === 'FSU/PRE') {
              return <span>FLT PRE</span>
            } else if (row?.type === 'FSU/DIS') {
              return <span>GDS RMV FLT</span>
            } else if (row?.type === 'FSU/FPS') {
              return <span>LOCATION CHANGE | {msgData.fromLocation || 'UNKNOWN'} TO {msgData.toLocation || 'UNKNOWN'}</span>
            }
            return <span>{row.type} | {msgData.fromLocation || '-'} TO {msgData.toLocation || '-'}</span>
          } else {
            return <span>{row.type}</span>
          }
        }
      },
      {
        title: 'ULD#',
        key: 'uld',
        dataIndex: 'uld',
        render: (_, row) => {
          let msgData = this.parseMsg(row.msg)
          if (row?.type === 'MANIFEST') {
            return <dic>{msgData?.ulds?.map((uld, index) => {
              // eslint-disable-next-line
              let conetent = uldData(uld, true)
              return uld?.utilizedUnitLoadTransportEquipment?.characteristicCode?.value && <Popover trigger='click' content={conetent} title='Current ULD Content' className='uld-popover' key={index} >
                {uld?.utilizedUnitLoadTransportEquipment?.characteristicCode?.value + '' + uld?.utilizedUnitLoadTransportEquipment?.id?.value + uld?.utilizedUnitLoadTransportEquipment?.operatingParty?.primaryID?.value}
              </Popover>
            })
            }</dic>
          }
          return <Popover trigger='click' title='Current ULD Content' className='uld-popover' onClick={() => this.getUldData(msgData.uld, row.station)} content={
            this.state.uldData && this.state.uldData?.id ? (<div className='' style={{ width: '400px' }}>
              {this.state.uldData?.awbs_in?.map((item, index) => (
                <Row gutter={16} key={index} style={{ marginBottom: 8 }}>
                  <Col span={10}>{item?.awb_no}</Col>
                  <Col span={4}>{item?.avl_pcs}PCS</Col>
                  <Col span={4}>{item?.wgt?.value}{item?.wgt?.unit}</Col>
                  <Col span={6}>{item?.org}-{item?.dest}</Col>
                </Row>
              ))}
            </div>)
              : 'Loading...'
          }>
            <div className='d-flex'>
              {msgData.uld}
              <span className='info-icon'><CaretDownOutlined style={{ fontSize: '8px' }} /></span>
            </div>
          </Popover>
        }
      },
      {
        title: 'Pieces',
        key: 'pieces',
        render: (_, row) => {
          let msgData = this.parseMsg(row.msg)
          return msgData.pcs
        }
      },
      {
        title: 'Weight',
        key: 'weight',
        render: (_, row) => {
          let msgData = this.parseMsg(row.msg)
          return msgData.wgt?.toFixed(2) + ' ' + msgData.unit
        }
      },
      {
        title: 'Flight',
        key: 'flight',
        render: (_, row) => {
          let msgData = this.parseMsg(row.msg)
          return msgData.flight.split(',').map((item, index) => {
            return <div onClick={() => this.getFlightData(item)} key={index} className='d-flex'>
              <div style={{ minWidth: '220px' }}>{item}</div>
              {item &&
                <Popover trigger='click' content={this.state.flightData?.flight_no && item.includes(this.state.flightData?.flight_no) ? (
                  <div className='' style={{ width: '400px' }}>
                    Arrival: {this.state.flightData?.arr?.utc ? moment.utc(this.state.flightData?.arr?.utc).tz(this.state.timezone).format(format) + ` ${this.state.ext}` : moment.utc(this.state.flightData?.arriv_date).tz(this.state.timezone).format(format) + ` ${this.state.ext}`}<br />
                    Arrival Gate: {this.state.flightData?.arr?.gate}<br />
                    Departure: {this.state.flightData?.dept?.utc ? moment.utc(this.state.flightData?.dept?.utc).tz(this.state.timezone).format(format) + ` ${this.state.ext}` : moment.utc(this.state.flightData?.dept_date).tz(this.state.timezone).format(format) + ` ${this.state.ext}`}<br />
                    Departure Gate: {this.state.flightData?.dept?.gate}
                  </div>
                ) : 'Loading...'} title='Flight Status' className='uld-popover'>
                  <span className='info-icon'><CaretDownOutlined style={{ fontSize: '8px' }} /></span>
                  {/* <span className='info-icon'>i</span> */}
                </Popover>
              }
            </div>
          }
          )
        }
      },
      {
        title: 'Location',
        key: 'location',
        dataIndex: 'location',
        render: (_, row) => {
          let msgData = this.parseMsg(row.msg)
          return msgData.toLocation
        }
      },
      {
        title: 'Local Date/Time',
        key: 'local_date_time',
        render: (_, row) => {
          if (row?.type === 'ECIBOOK') {
            // Tue Apr 29 08:52:31 UTC 2025
            return row?.msg?.bookingPublishEvent && <span>{moment.utc(row?.msg?.bookingPublishEvent?.eventMetadata?.timestamp).tz(this.state.timezone).format(format) + ` ${this.state.ext}`}</span>
          } else if (row?.type?.includes('FSU') || row?.type === 'MANIFEST') {
            return <span>{moment.utc(row?.msg?.messageHeaderDocument?.issueDateTime).tz(this.state.timezone).format(format) + ` ${this.state.ext}`}</span>
          }
          return <span>{row?.createdAt ? moment.utc(row.createdAt).tz(this.state.timezone).format(format) + ` ${this.state.ext}` : 'N/A'}</span>
        }
      },
      // {
      //   title: 'GMT Date/Time',
      //   key: 'gmt_date_time',
      //   render: (_, row) => {
      //     if (row?.type === 'ECIBOOK') {
      //       // Tue Apr 29 08:52:31 UTC 2025
      //       return <span>{moment.utc(row?.msg?.bookingPublishEvent?.eventMetadata?.timestamp).format(format) + ' UTC'}</span>
      //     } else if (row?.type?.includes('FSU') || row?.type === 'MANIFEST') {
      //       return <span>{moment.utc(row?.msg?.messageHeaderDocument?.issueDateTime).format(format) + ' UTC'}</span>
      //     }
      //     return <span>{row?.createdAt ? moment(row.createdAt).format(format) + ' UTC' : 'N/A'}</span>
      //   }
      // },
    ]

    const uldData = (data, ffm = false) => {
      if (ffm) {
        return <div className='' style={{ width: '400px' }}>
          {data?.includedMasterConsignment?.map((item, index) => (
            <Row gutter={16} key={index} style={{ marginBottom: 8 }}>
              <Col span={10}>{item?.transportContractDocument?.id?.value}</Col>
              <Col span={4}>{item?.totalPieceQuantity?.value}PCS</Col>
              <Col span={4}>{item?.grossWeightMeasure?.value}{item?.grossWeightMeasure?.unitCode}</Col>
              <Col span={6}>{item?.originLocation?.id?.value}-{item?.finalDestinationLocation?.id?.value}</Col>
            </Row>
          ))}
        </div>
      } else {
        return <div className='' style={{ width: '400px' }}></div>
      }
    }
    const content = (
      <> 
        <Checkbox.Group options={this.state.plainOptions} value={this.state.checkedList} onChange={this.onChangeCheck} />
        <div>
          <Button type='link' className='subscribe-btn w-100 mt-2' onClick={this.onSubscibe}>Submit</Button>
        </div>
      </>
    )

    return (
      <Card className='custom-card h-100'>
        <Row gutter={[{
          xs: 0,
          sm: 0,
          md: 10,
          lg: 10
        }, {
          xs: 10,
          sm: 10,
          md: 20,
          lg: 20
        },]}
        >
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className='awb-search'>
            <div className='awb-wrapper'>
              <Search
                size='middle'
                placeholder='AWB Number'
                value={this.state.search.number}
                name='number'
                onChange={this.onChange}
                className='awb-number'
                allowClear
                onSearch={this.onSearch}
              />
            </div>
          </Col>

          {this.state.notFound ? <Col xs={24}>
            <Typography.Text strong className='awb-not-found'>AWB not found</Typography.Text>
          </Col>
            : ''}
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <div className='detail-wrapper'>
              <Row gutter={[24, 24]}>
                <Col flex='1 1 200px'>
                  <Card className='awb-detail-card' size='small' variant='borderless'>
                    <Typography.Text className='awb-label'>Shipment Details</Typography.Text>
                    <Space direction='vertical' size={4}>
                      <Space direction='horizontal' size={2} align='center' className='awb-route'>
                        <Typography.Title level={4} className='mb-0'> {this.state.awbData?.org} </Typography.Title>
                        {this.state.awbData?.org && this.state.awbData?.dest ?
                          <div className='plane-icon px-2'>
                            <img src={planeDarkIcon} width='15' height='15' alt='plane' />
                          </div> : ''}
                        <Typography.Title level={4} className='mb-0'> {this.state.awbData?.dest} </Typography.Title>
                      </Space>
                      <Space direction='horizontal' size={8} align='center' >
                        <Typography.Text type='secondary' className='mb-0'> Pcs:
                          <Typography.Text strong className='mb-0'> {this.state.awbData?.pcs || 0}</Typography.Text>
                        </Typography.Text>
                        <Typography.Text type='secondary' className='mb-0'> Wgt:
                          <Typography.Text strong className='mb-0'> {(this.state.awbData?.wgt || 0) + '' + (this.state.awbData?.unit || '')}</Typography.Text>
                        </Typography.Text>
                      </Space>
                    </Space>
                  </Card>
                </Col>
                <Col flex='1 1 200px'>
                  <Card className='awb-detail-card' size='small' variant='borderless'>
                    <Typography.Text className='awb-label'>Product</Typography.Text>
                    <Typography.Title level={4}> {this.state.awbData?.prod_code} </Typography.Title>
                  </Card>
                </Col>
                <Col flex='1 1 200px'>
                  <Card className='awb-detail-card' size='small' variant='borderless'>
                    <Typography.Text className='awb-label'>Planning Info</Typography.Text>
                    <Space size={0} direction='vertical' className='mt-2'>
                      <Typography.Text type='secondary' className='mb-0'> Priority:
                        <Typography.Text strong className='mb-0'></Typography.Text>
                      </Typography.Text>
                      <Typography.Text type='secondary' className='mb-0'> DOD Plan:
                        <Typography.Text strong className='mb-0'></Typography.Text>
                      </Typography.Text>
                      <div >
                        <Typography.Text type='secondary' className='mb-0'> DOD Remark:
                        </Typography.Text>
                        <Typography.Text strong className='mb-0'></Typography.Text>
                      </div>
                    </Space>
                    <Typography.Title level={4}> </Typography.Title>
                  </Card>
                </Col>
                <Col flex='1 1 200px'>
                  <Card className='awb-detail-card' size='small' variant='borderless'>
                    <Typography.Text className='awb-label'>Current Booking Status</Typography.Text>
                    <Typography.Title level={4}> {this.state.awbData?.status} </Typography.Title>
                  </Card>
                </Col>
                <Col flex='1 1 200px'>
                  <Card className='awb-detail-card' size='small' variant='borderless'>
                    <Typography.Text className='awb-label'>Hub Control Action</Typography.Text>
                    <div style={{
                      height: '80px',
                      overflowY: 'auto',
                      marginRight: '-12px'
                    }}>
                      {this.state.audit?.map((item, index) => {
                        return <div className='mt-2' key={index}>
                          <Typography.Paragraph strong className='mb-0'> &#x2022; {item?.message} </Typography.Paragraph>
                          <Typography.Text type='secondary' style={{
                            fontSize: '12px',
                            lineHeight: 'normal',
                            marginLeft: '20px',
                          }}>{item.station} | {item.createdAt ? moment(item.createdAt).format(format) + ' UTC' : ''} </Typography.Text>
                        </div>
                      }
                      )}
                    </div>
                  </Card>
                </Col>
                <Col flex='1 1 200px'>
                  <Card className='awb-detail-card' size='small' variant='borderless'>
                    <Space direction='horizontal' size={2} align='center' className='f-spacebtw awb-label'>
                      <Typography.Text className='awb-label-notify' >Notifications</Typography.Text>
                    </Space>
                    <div style={{
                      height: '80px',
                      overflowY: 'auto',
                      marginRight: '-12px'
                    }}>
                      <ul className='subscribed-users mt-2'>
                        {this.state.subscribedUsers?.length === 0 ? <li>No users subscribed</li> : ''}
                        {this.state.subscribedUsers?.length > 0 && this.state.subscribedUsers?.map((user, index) => (
                          <li key={index}>{user?.user?.name?.first_name} {user?.user?.name?.last_name} subscribed to the notifications</li>
                        ))}
                      </ul>
                      
                      <div className='subscribe-wrapper'>
                        <Popover trigger='click' content={content} title={
                          <Space direction='horizontal' size={2} align='center' className='f-spacebtw'>
                            <Typography.Text>Notifications</Typography.Text>
                            <Checkbox indeterminate={indeterminate} onChange={this.onCheckAllChange} checked={checkAll}>Select all</Checkbox>
                          </Space>
                        }
                        overlayClassName='tnt-popover'
                        className='uld-popover'>
                          <Button className='subscribe-btn'>
                            {this.state.subscribe ? 'Unsubscribe' : 'Subscribe'}
                          </Button>
                        </Popover>
                      </div>
                    </div>
                  </Card>
                </Col>
              </Row>
            </div>
          </Col>

          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Table
              dataSource={this.state.data}
              columns={columns}
              className='awb-table mt-4'
              rowClassName={(record, index) => index % 2 === 0 ? 'row-light' : 'row-dark'}
              size='small'
              pagination={false}
              bordered={false}
            />
          </Col>
        </Row>
      </Card>

    )
  }
}

export default AwbDetails
